import { useContext, useEffect, useState, useCallback } from "react";
import { Button, Chip, Stack, Typography, CircularProgress } from "@mui/joy";
import { NotificationsActiveRounded, NotificationsOffRounded } from "@mui/icons-material";
import { LayoutContext } from "../context";
import { getPushStatus, requestPush } from "../push";

export default function PushNotificationButton({ sx }) {
    const { token } = useContext(LayoutContext);
    const [status, setStatus] = useState('loading'); // loading|connected|not_connected|blocked|ios_need_install|unsupported
    const [busy, setBusy] = useState(false);
    const [hint, setHint] = useState('');

    const refresh = useCallback(async () => {
        try { setStatus(await getPushStatus()); }
        catch { setStatus('not_connected'); }
    }, []);

    useEffect(() => { if (token) refresh(); }, [token, refresh]);

    const handleConnect = async () => {
        setBusy(true); setHint('');
        const res = await requestPush();
        if (res.type === 'success') setHint('Готово ✅');
        else if (res.type === 'ios_need_install') setHint('На iPhone: «Поделиться» → «На экран Домой», затем откройте как приложение.');
        else if (res.type === 'permission_denied_permanent') setHint('Разрешите уведомления в настройках сайта браузера.');
        else if (res.type === 'permission_denied') setHint('Разрешение не выдано.');
        else if (res.type === 'no_vapid_key') setHint('Не задан VAPID-ключ (src/push.js).');
        await refresh();
        setBusy(false);
    };

    if (status === 'loading') return <CircularProgress size="sm" sx={sx} />;

    if (status === 'connected') {
        return (
            <Chip color="success" variant="soft" startDecorator={<NotificationsActiveRounded />} sx={sx}>
                Уведомления подключены
            </Chip>
        );
    }

    if (status === 'unsupported') {
        return (
            <Chip color="neutral" variant="soft" startDecorator={<NotificationsOffRounded />} sx={sx}>
                Push не поддерживается
            </Chip>
        );
    }

    return (
        <Stack spacing={1} sx={sx}>
            <Button
                color="primary"
                startDecorator={<NotificationsActiveRounded />}
                loading={busy}
                onClick={handleConnect}
                disabled={status === 'ios_need_install' || status === 'blocked'}
            >
                Подключить уведомления
            </Button>
            {status === 'ios_need_install' && (
                <Typography level="body-sm" color="neutral">
                    На iPhone добавьте сайт на экран «Домой», чтобы включить уведомления.
                </Typography>
            )}
            {status === 'blocked' && (
                <Typography level="body-sm" color="warning">
                    Уведомления заблокированы в браузере — разрешите их в настройках сайта.
                </Typography>
            )}
            {hint && <Typography level="body-sm">{hint}</Typography>}
        </Stack>
    );
}